(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-1"] && !Shopify.designMode) return;
  try {
    
  // NOTE: {% javascript %} is served as a static asset and is NOT run through
  // Liquid, so `{{ section.id }}` here would stay a literal string. The original
  // selectors interpolated the section id, matched nothing, and the function
  // returned on its first line - which is why the dots never tracked scrolling.
  // Everything below is resolved from the DOM instead, and it now supports more
  // than one instance of the section on a page.
  (function() {
    function initCarousel(container) {
      var wrapper = container.querySelector('.featured_wrapper');
      var dotsContainer = container.querySelector('.featured_dots');
      if (!wrapper || !dotsContainer) return;

      var dots = dotsContainer.querySelectorAll('.featured_dot');
      var slides = wrapper.querySelectorAll('.featured_carousel-slide');

      // Click a dot to scroll to that slide.
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          if (slides[index]) {
            slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });

      function setActive() {
        var wrapperRect = wrapper.getBoundingClientRect();
        var wrapperCenter = wrapperRect.left + wrapperRect.width / 2;
        var closestIndex = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var slideRect = slide.getBoundingClientRect();
          var slideCenter = slideRect.left + slideRect.width / 2;
          var distance = Math.abs(wrapperCenter - slideCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === closestIndex);
          d.setAttribute('aria-current', i === closestIndex ? 'true' : 'false');
        });
      }

      // rAF rather than a 100ms debounce: the dot now moves *during* the swipe
      // instead of settling a beat after the finger lifts, which is what made it
      // feel like it wasn't tracking at all.
      var ticking = false;
      wrapper.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            setActive();
            ticking = false;
          });
        },
        { passive: true }
      );

      setActive();
    }

    document.querySelectorAll('[class*="featured_custom-"]').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
